import React, { FormEvent } from 'react';
import styled from 'styled-components';

interface Props {
  id: string;
  disabled?: boolean;
  checked: boolean;
  onChange: (e: FormEvent<HTMLInputElement>) => void;
  label: string;
}

const CheckboxInputRow = ({ id, disabled, checked, onChange, label}: Props) => {
  return <Row>
    <Checkbox type="checkbox" id={id} disabled={disabled} checked={checked} onChange={onChange}/>
    <Label htmlFor={id}>{label}</Label>
  </Row>;
};

const Row = styled.div`
  margin: 20px 0;
`;

const Checkbox = styled.input`
  margin: 0 8px 0 0;
`;

const Label = styled.label`
  font-size: 20px;
`;

export default CheckboxInputRow;
